export default __webpack_public_path__ + "static/media/9.b59492d1.jpg";